import styled from 'styled-components';
import { SearchIcon } from 'components/icons';

const SearchBar = ({ placeholder, search }) => (
    <SearchWrapper>
        <input
            type="search"
            placeholder={placeholder}
            tabIndex="-1"
            onChange={(e) => search(e.target.value)}
        />
        <SearchButton>
            <SearchIcon />
        </SearchButton>
    </SearchWrapper>
);

const SearchWrapper = styled.div`
    position: relative;
    width: 280px;
    display: flex;
    align-items: center;

    input {
        width: 100%;
        height: 34px;
        border: none;
        border-radius: 0;
        border-bottom: ${({ theme }) => `1px solid ${theme.colors.primary}`};
        background-color: transparent;
        -webkit-appearance: none;
        ::placeholder {
            font-family: var(--futura-font);
            font-weight: ${({ theme }) => theme.fontWeights.medium};
            font-size: ${({ theme }) => theme.sizes.xs};
            color: ${({ theme }) => theme.colors.primary};
            line-height: 18px;
            letter-spacing: 1px;
        }
        :focus {
            outline: none;
        }
        //for hide clear icon
        ::-webkit-search-decoration,
        ::-webkit-search-cancel-button,
        ::-webkit-search-results-button,
        ::-webkit-search-results-decoration {
            display: none;
        }
    }
`;

const SearchButton = styled.button`
    position: absolute;
    border: none;
    right: 0;
    background-color: transparent;
    svg {
        width: 12px;
    }
`;
export default SearchBar;
